import PaginationResponseDto from '../interfaces/paginationResponse.interface';
import { API_ROUTES } from '../consts';
import { buildOrder, buildRequestParamsByType, buildSelect } from '../utils/request';
import { RequestQueryBuilderParamsEnum } from '../consts/enums';
import { Update, EditUpdates } from '../@types/update';
import request from './index';

export const updateUpdates = async (ids: string[], data: EditUpdates): Promise<void> => {
  return request.patch(API_ROUTES.UPDATES, data, { params: { ids: ids.join(',') } });
};

export const getUpdate = async (query: ApiQuery): Promise<PaginationResponseDto<Update>> => {
  const { where } = query;
  const { data } = await request.get(API_ROUTES.UPDATES, {
    params: {
      ...where,
      ...buildRequestParamsByType(query.contains || {}, RequestQueryBuilderParamsEnum.contains),
      ...buildRequestParamsByType(query.in || {}, RequestQueryBuilderParamsEnum.in),
      order: buildOrder(query.order || {}),
      select: buildSelect(query.select),
      page: query.page,
      limit: query.limit,
    },
  });
  const {
    results, page, totalCount, limit,
  } = data;

  return {
    results,
    page,
    totalCount,
    limit,
  };
};
